import { apiFGTS } from '../http/httpClient'

export async function checkCpf(cpf: string): Promise<{ blocked: boolean }> {
  const { data } = await apiFGTS.get<{ blocked: boolean }>(
    `/transaction/check-cpf/${cpf}`,
  )
  return data
}
